import { useMainStore } from '@/stores/main';
import { useRequestEvent } from 'nuxt/app';

export default defineNuxtRouteMiddleware(async (to) => {
  const store = useMainStore();
  if (!Array.isArray(store.categories) || store.categories.length === 0) {
    let req = {};
    if (import.meta.server) {
      const event = useRequestEvent();
      if (event && event.node && event.node.req) {
        req = event.node.req;
      }
    }
    await store.serverInit({ route: to, req });
  }
});
